import React from 'react';
import PropTypes from 'prop-types';
import { SimpleSelect } from 'react-selectize-advizr';

export const DropdownAlignments = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT',
};

export const AdvDropdown = props => {
  const {
    dropdownAlignment,
    options,
    groups,
    onOptionSelect,
    className,
    placeholder,
    optionMapper,
  } = props;

  let alignmentClass = '';
  switch (dropdownAlignment) {
    case DropdownAlignments.LEFT:
      alignmentClass = ' left';
      break;
    case DropdownAlignments.RIGHT:
      alignmentClass = ' right';
      break;
    default:
      alignmentClass = ' left';
  }

  return (
    <div className={`r-adv-dropdown-parent${alignmentClass}`}>
      <SimpleSelect
        value={{
          label: '',
          value: '',
        }}
        groups={groups}
        closeOnSelect
        onValueChange={object => {
          onOptionSelect(object.value);
        }}
        className={`r-adv-dropdown ${className}`}
        options={options.map(optionMapper)}
        inputProps={{
          'aria-label': placeholder,
        }}
      />
      <div className="placeholder">{placeholder}</div>
    </div>
  );
};

AdvDropdown.defaultProps = {
  className: '',
  optionMapper: option => ({
    label: option,
    value: option,
  }),
  groups: null,
};

AdvDropdown.propTypes = {
  dropdownAlignment: PropTypes.oneOf(Object.values(DropdownAlignments)).isRequired,
  options: PropTypes.arrayOf(PropTypes.any).isRequired,
  groups: PropTypes.arrayOf(PropTypes.shape({})),
  onOptionSelect: PropTypes.func.isRequired,
  className: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  optionMapper: PropTypes.func,
};
